import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * The AB reducer manages all experiments this app cares about
 * and all experiments that are currently active. `active`
 * meaning rendered into the DOM and visible to the user.
 */
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import get from 'lodash/get';
import * as Actions from './actions';
/* eslint-disable no-case-declarations */

export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    availableExperiments: {},
    currentlyActiveExperiments: {},
    preventPageviewReset: false
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case Actions.EEE_REPORTED:
    case Actions.ACTIVATE_EXPERIMENT:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentlyActiveExperiments: _objectSpread(_objectSpread({}, state.currentlyActiveExperiments), {}, _defineProperty({}, action.experimentID, state.availableExperiments[action.experimentID]))
      });

    case Actions.PREVENT_IMPRESSIONS_RESET_ON_PAGEVIEW:
      return _objectSpread(_objectSpread({}, state), {}, {
        preventPageviewReset: true
      });

    case Actions.DEACTIVATE_EXPERIMENT:
      var currentlyActiveExperiments = _objectSpread({}, state.currentlyActiveExperiments);

      delete currentlyActiveExperiments[action.experimentID];
      return _objectSpread(_objectSpread({}, state), {}, {
        currentlyActiveExperiments: currentlyActiveExperiments
      });

    case Actions.LOAD_EXPERIMENT:
      return _objectSpread(_objectSpread({}, state), {}, {
        availableExperiments: _objectSpread(_objectSpread({}, state.availableExperiments), {}, _defineProperty({}, action.experimentID, {
          variantName: action.variantName,
          isExternallyLoaded: true
        }))
      });

    case Actions.ADD_EXPERIMENT:
      if (get(state, "availableExperiments[".concat(action.experiment.testName, "]"))) {
        return state;
      }

      return _objectSpread(_objectSpread({}, state), {}, {
        availableExperiments: _objectSpread(_objectSpread({}, state.availableExperiments), {}, _defineProperty({}, action.experiment.testName, action.experiment))
      });

    case Actions.RESET_IMPRESSONS:
    case Actions.UPDATE_HISTORY:
    case Actions.LOCATION_CHANGE:
    case Actions.UPDATE_PATH:
      // Manually prevent reset for exposed experiments
      if (state.preventPageviewReset) {
        return state;
      } // A page view should reset any exposed experiments


      return {
        availableExperiments: _objectSpread({}, state.availableExperiments),
        currentlyActiveExperiments: {}
      };

    default:
      return state;
  }
});
/* eslint-enable no-case-declarations */